import React from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from "uuid";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "@mui/material/Button";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Stepper, Step, StepLabel, Typography, Container, Box } from '@mui/material';
import { addEntity } from "../../lib/services/api-service";
import { TableName } from "../../constants/table";
import { FormInputText } from "../formComponent/FormInputText";
import { FormInputNumber } from "../formComponent/FormInputNumber";
import { useGetTenants } from "../../lib/query/manageTenants";
import { IManageTenant } from "../../models/managetenant";
import TenantContext from "../../lib/context/TenantContext";
import { validateTenants } from "./helper";

const AddTenant = () => {
  const navigate = useNavigate();
  const { tenant } = React.useContext(TenantContext);
  const { refetch } = useGetTenants();
  const [activeStep, setActiveStep] = React.useState(0);

  const steps = ['Add New Tenant', 'Add Tenant Admin'];

  const schema = yup
    .object()
    .shape({
      rowKey: yup.string().required("Company is a required field"),
      CompanyLicenses: yup
        .number()
        .required("Company Licenses is a required field")
        .min(1, "Company Licenses must be at least 1"),
    })
    .required();

  const { handleSubmit, control, reset } = useForm<IManageTenant>({
    resolver: yupResolver(schema),
    defaultValues: {
      CompanyLicenses: 1,
    },
  });

  const onSubmit = async (data: IManageTenant) => {
    const tenantId = tenant.id.toLowerCase();
    const isTenantValid = await validateTenants(
      tenantId,
      data.rowKey.toLowerCase()
    );
    if (!isTenantValid) {
      toast.warn("Tenant already exists!");
      return;
    }

    const TenantId = uuidv4();
    await addEntity(TableName.Tenant, {
      partitionKey: TenantId,
      rowKey: data.rowKey,
      CompanyLicenses: data.CompanyLicenses,
    })
      .then(() => {
        toast.success(
          `Successfully added new Tenant with name: ${data.rowKey}`
        );
        refetch();
        reset();
        setActiveStep(1);
        navigate('/super-admin/manageTenants');
      })
      .catch((err) => {
        toast.error(`Failed with error ${err}`);
      });
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ width: '100%', mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          New Tenant
        </Typography>
        <Stepper activeStep={activeStep}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Box sx={{ mt: 4 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormInputText name="rowKey" control={control} label="Company" />
            <Box sx={{ mt: 2 }}>
              <FormInputNumber
                name="CompanyLicenses"
                control={control}
                label="Company Licenses"
              />
            </Box>
            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="submit" variant="contained" color="primary">
                Add and Continue
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Container>
  );
};

export default AddTenant;